// extracted by mini-css-extract-plugin
module.exports = {"button":"signers_button__13-7j"};